import { useTranslation } from "react-i18next";
import { Niveaus } from "@/features/stamgegevens/Niveaus";
import { BeheerderShell } from "@/components/BeheerderShell";

export function NiveausPage() {
  const { t } = useTranslation(["paginas", "navigatie"]);

  return (
    <BeheerderShell
      titel={t("navigatie:paginas.niveaus.label")}
      uitleg={t("niveaus.uitleg")}
    >
      <Niveaus />
    </BeheerderShell>
  );
}
